// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3iszP","amount":"Amount_amount__1OZI2","tip":"Amount_tip__1Tg-s","tipHeader":"Amount_tipHeader__T3B2d","tipsWrap":"Amount_tipsWrap__2ex6M"};